export default __webpack_public_path__ + "static/media/1389.2eb9aad4.png";